import { render, staticRenderFns } from "./OtherInvestigation.vue?vue&type=template&id=1a4d3690&scoped=true"
import script from "./OtherInvestigation.vue?vue&type=script&lang=js"
export * from "./OtherInvestigation.vue?vue&type=script&lang=js"
import style0 from "./OtherInvestigation.vue?vue&type=style&index=0&id=1a4d3690&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4d3690",
  null
  
)

export default component.exports